import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportsService } from 'src/app/Services/reports/reports.service';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboardService } from 'src/app/Services/Dashboard/dashboard.service';
import { DropDownResponse,DashboardFilters, Year} from 'src/app/Models/Dashboard/DashboardFilters';
import { ToastrModule, ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-annual-requirement-status-report',
  templateUrl: './annual-requirement-status-report.component.html',
  styleUrls: ['./annual-requirement-status-report.component.css'],
  providers: [DatePipe]
})
export class AnnualRequirementStatusReportComponent implements OnInit {
  loader: string = 'none';
  roleID: string;
  selectedYear: any[] = [];
  @ViewChild('year') year;
  yearSettings: IDropdownSettings  = {};
  selectedRequirementYear: any = '';
  public ddlResponse: DropDownResponse = new DropDownResponse();
 
  constructor(private dashboardService: DashboardService,
    private reportsService:ReportsService,private snackBar:MatSnackBarComponent, 
    private router: Router, private datepipe: DatePipe,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID'); }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getDashboardFiltersOnPageLoad();
    this.YearSettings();
  }

  getDashboardFiltersOnPageLoad() {
    debugger;
    this.loader = 'block';
    this.dashboardService.dashboardFilters()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.ddlResponse = resData.data;
          class YearItemList{
            id: any;
            text: string;
        }
          let requiredItem: YearItemList[] = [];
          var obj = {
            id : this.ddlResponse.requirementYear[this.ddlResponse.requirementYear.length - 1].year,
            text: this.ddlResponse.requirementYear[this.ddlResponse.requirementYear.length - 1].year
          }
          requiredItem.push(obj)
          this.year.selectedItems=requiredItem;
          //let cYear=requiredItem;
          this.loader = 'none';
        //this.onCurrentYearSelected(this.ddlResponse.year)
        }
        
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  YearSettings(){
    this.yearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  downloadAnnualStatusReport() {
    this.loader = 'block';
    let selectedYear = '';
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.reportsService.getAnnualStatusReport(selectedYear)
      .subscribe(
        success => {
          var date=new Date();
          let latest_date =this.datepipe.transform(date, 'dd-MMM-yy')
          let name =localStorage.getItem('mcmt_userName').split(' ');
          let firstname=name[0];
          let lastName=name[1];
          let cYear = this.year.selectedItems[0].id;
          let excelName=firstname+'_'+lastName + '_'+ cYear +'_AnnualStatusReport_'+latest_date+'.xlsx';
          saveAs(success, excelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          //this.snackBar.openSnackBar("No record/s available", 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      );
  }
  //Download Approval Status Report in Excel
  downloadApprovalStatusReport() {
    this.loader = 'block';
    let selectedYear = '';
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.reportsService.getApprovalStatusReport(selectedYear)
      .subscribe(
        success => {
          var date=new Date();
          let latest_date =this.datepipe.transform(date, 'dd-MMM-yy')
          let name =localStorage.getItem('mcmt_userName').split(' ');
          let firstname=name[0];
          let lastName=name[1];
          let cYear = this.year.selectedItems[0].id;
          let excelName=firstname+'_'+lastName+ '_'+ cYear +'_ApprovalStatusReport_'+latest_date+'.xlsx';
          saveAs(success, excelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          //this.snackBar.openSnackBar("No record/s available", 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      );
  }
  //Download Consolidated Requirement Report in Excel
  downloadConsolidatedRequirementReport() {
    this.loader = 'block';
    let selectedYear = '';
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.reportsService.getConsolidatedRequirementReport(selectedYear)
      .subscribe(
        success => {
          var date=new Date();
          let latest_date =this.datepipe.transform(date, 'dd-MMM-yy')
          let name =localStorage.getItem('mcmt_userName').split(' ');
          let firstname=name[0];
          let lastName=name[1];
          let cYear = this.year.selectedItems[0].id;
          let excelName=firstname+'_'+lastName+ '_'+ cYear +'_ConsolidatedRequirementReport_'+latest_date+'.xlsx';
          saveAs(success, excelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          //this.snackBar.openSnackBar("No record/s available", 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      );
  }
}
